/* Sticky contact dock: reveal after scrolling past the header; remember collapsed/open per browser. */
(function () {
  var dock = document.querySelector('[data-contact-dock]');
  if (!dock) return;
  var KEY = 'ce-contact-dock';
  var collapsed = false;
  try { collapsed = localStorage.getItem(KEY) === 'collapsed'; } catch (e) {}
  var designMode = window.Shopify && window.Shopify.designMode;
  var threshold = Number(dock.getAttribute('data-show-after') || 320);

  function apply() {
    dock.classList.toggle('is-collapsed', collapsed);
    var toggles = dock.querySelectorAll('[data-dock-toggle]');
    for (var i = 0; i < toggles.length; i++) toggles[i].setAttribute('aria-expanded', String(!collapsed));
  }
  function onScroll() {
    dock.classList.toggle('is-visible', designMode || window.scrollY > threshold);
  }
  dock.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dock-toggle]');
    if (!t) return;
    collapsed = !collapsed;
    try { localStorage.setItem(KEY, collapsed ? 'collapsed' : 'open'); } catch (err) {}
    apply();
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  apply();
  onScroll();
})();
